angular.module("coursemap").component("student", {
  templateUrl: "templates/student/landing.html",
  controller: "studentCtrl",
  controllerAs: "studentCtrl"
})
